import styled from 'styled-components';
import v from 'scss/v';

export default styled.i`
  &::before {
    content: '*';
    padding-${v('$right')}: .5rem;
    padding-inline-end: .5rem;
    color: ${v('$danger')};
  }
`;
